import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import {Router} from '@angular/router';
import { ArtikelService } from '../services/artikel.service';


@Component({
  selector: 'sws-infoheader',
  templateUrl: './infoheader.component.html',
  styleUrls: ['./infoheader.component.css']
})
export class InfoheaderComponent implements OnInit {

  constructor(public authService: AuthService, private router: Router,
              private artSuche: ArtikelService) {

  }

  ngOnInit() {

  }
  /* zur Seite Anmeldung */
  login() {
       /* Programm startet in Infohome */
      this.router.navigateByUrl('/login');
   
  }

  /* Abmeldung */
  logout() {
    this.authService.logout();
    this.artSuche.Initialisieren();
    this.router.navigateByUrl('/home');
  }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/infoheader/infoheader.component.ts